// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"22f2b05e","732":"ede21cd6","977":"7a39ae08"}[chunkId] + ".chunk.js";
};